module.exports = __webpack_public_path__ + "img/newicon.28bf43a1.png";